import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { IoMdClose } from 'react-icons/io';
import Draggable from 'react-draggable';
import { useCADManager, useGetElementInfo } from 'hooks';
import { CADGap } from 'styles/constants';
import { FloatingTabsID } from 'constants/cad';
import { IconStyled } from './floatingWindow.styled';

const floatingID = 'floatingWindow';

type FloatingWindowProps = {
  onClose: () => void;
  title: React.ReactNode;
  inner: React.ReactNode;
};

const FloatingWindow = observer(
  ({ onClose, title, inner }: FloatingWindowProps) => {
    const { panelAndSidebarWidth, viewerControl } = useCADManager();
    const [isExpanded, setIsExpanded] = useState(true);

    const winIcon = isExpanded ? 'minimize' : 'maximize';

    const { height: floatTabHeight = 0 } = useGetElementInfo(
      `#${FloatingTabsID}`,
    );

    if (!inner) return null;

    const floatTabGapAndHeight = floatTabHeight
      ? CADGap * 2 + floatTabHeight
      : 0;

    return (
      <Draggable
        handle='#measurementDragTrigger'
        bounds={`#${viewerControl.canvasId}`}
      >
        <div
          id={floatingID}
          className={` ${
            isExpanded ? 'w-96 h-fit' : 'w-fit h-fit'
          } absolute border border-wfGrey100 bg-white shadow-md z-[1005]`}
          style={{
            top: CADGap + floatTabGapAndHeight,
            left: panelAndSidebarWidth + CADGap,
          }}
        >
          <div
            id='measurementDragTrigger'
            className='flex py-2 px-4 w-full justify-between items-center cursor-move border-b border-wfGrey100'
          >
            <h2 className='text-sm text-black w-fit mr-2'>{title}</h2>
            <div className=' flex items-center'>
              <IconStyled
                name={winIcon}
                viewBox='0 0 40 40'
                onClick={() => {
                  setIsExpanded(!isExpanded);
                }}
              />
              <IoMdClose
                size={22}
                onClick={onClose}
                className=' cursor-pointer text-base text-wfBlue'
              />
            </div>
          </div>
          {isExpanded ? inner : null}
        </div>
      </Draggable>
    );
  },
);

export default FloatingWindow;
